import adhesiveBandage from '../code-only/assets/emoji_iconpack/adhesive_bandage.webp'
import alienMonster from '../code-only/assets/emoji_iconpack/alien_monster.webp'
import ambulance from '../code-only/assets/emoji_iconpack/ambulance.webp'
import amphora from '../code-only/assets/emoji_iconpack/amphora.webp'
import armoredChicken from '../code-only/assets/emoji_iconpack/armored_chicken.webp'
import astronaut from '../code-only/assets/emoji_iconpack/astronaut.webp'
import automobile from '../code-only/assets/emoji_iconpack/automobile.webp'
import balanceScale from '../code-only/assets/emoji_iconpack/balance_scale.webp'
import bank from '../code-only/assets/emoji_iconpack/bank.webp'
import banknoteDollar from '../code-only/assets/emoji_iconpack/banknote_dollar.webp'
import banknoteEuro from '../code-only/assets/emoji_iconpack/banknote_euro.webp'
import barberPole from '../code-only/assets/emoji_iconpack/barber_pole.webp'
import beerMug from '../code-only/assets/emoji_iconpack/beer_mug.webp'
import bellshop from '../code-only/assets/emoji_iconpack/bellshop.webp'
import blueBook from '../code-only/assets/emoji_iconpack/blue_book.webp'
import brain from '../code-only/assets/emoji_iconpack/brain.webp'
import brick from '../code-only/assets/emoji_iconpack/brick.webp'
import briefcase from '../code-only/assets/emoji_iconpack/briefcase.webp'
import buildingConstruction from '../code-only/assets/emoji_iconpack/building_construction.webp'
import calendar from '../code-only/assets/emoji_iconpack/calendar.webp'
import cameraWithFlash from '../code-only/assets/emoji_iconpack/camera_with_flash.webp'
import cannedFood from '../code-only/assets/emoji_iconpack/canned_food.webp'
import cardFileBox from '../code-only/assets/emoji_iconpack/card_file_box.webp'
import checkMark from '../code-only/assets/emoji_iconpack/check_mark.webp'
import checkMarkButton from '../code-only/assets/emoji_iconpack/check_mark_button.webp'
import child from '../code-only/assets/emoji_iconpack/child.webp'
import circleCheck from '../code-only/assets/emoji_iconpack/circle_check.webp'
import circleExclamation from '../code-only/assets/emoji_iconpack/circle_exclamation.webp'
import clipboard from '../code-only/assets/emoji_iconpack/clipboard.webp'
import cloudWithRain from '../code-only/assets/emoji_iconpack/cloud_with_rain.webp'
import coin from '../code-only/assets/emoji_iconpack/coin.webp'
import collision from '../code-only/assets/emoji_iconpack/collision.webp'
import computerDisk from '../code-only/assets/emoji_iconpack/computer_disk.webp'
import construction from '../code-only/assets/emoji_iconpack/construction.webp'
import constructionWorker from '../code-only/assets/emoji_iconpack/construction_worker.webp'
import cook from '../code-only/assets/emoji_iconpack/cook.webp'
import couchAndLamp from '../code-only/assets/emoji_iconpack/couch_and_lamp.webp'
import coupleWithHeart from '../code-only/assets/emoji_iconpack/couple_with_heart.webp'
import crayon from '../code-only/assets/emoji_iconpack/crayon.webp'
import creditCard from '../code-only/assets/emoji_iconpack/credit_card.webp'
import crown from '../code-only/assets/emoji_iconpack/crown.webp'
import deliveryTruck from '../code-only/assets/emoji_iconpack/delivery_truck.webp'
import derelictHouse from '../code-only/assets/emoji_iconpack/derelict_house.webp'
import dove from '../code-only/assets/emoji_iconpack/dove.webp'
import downcastSweat from '../code-only/assets/emoji_iconpack/downcast_sweat.webp'
import droplet from '../code-only/assets/emoji_iconpack/droplet.webp'
import electricPlug from '../code-only/assets/emoji_iconpack/electric_plug.webp'
import envelope from '../code-only/assets/emoji_iconpack/envelope.webp'
import eyes from '../code-only/assets/emoji_iconpack/eyes.webp'
import faceWithCrossedOutEyes from '../code-only/assets/emoji_iconpack/face_with_crossed_out_eyes.webp'
import faceWithHeadBandage from '../code-only/assets/emoji_iconpack/face_with_head_bandage.webp'
import faceWithThermometer from '../code-only/assets/emoji_iconpack/face_with_thermometer.webp'
import factoryWorker from '../code-only/assets/emoji_iconpack/factory_worker.webp'
import fearfulFace from '../code-only/assets/emoji_iconpack/fearful_face.webp'
import fire from '../code-only/assets/emoji_iconpack/fire.webp'
import fireExtinguisher from '../code-only/assets/emoji_iconpack/fire_extinguisher.webp'
import firefighter from '../code-only/assets/emoji_iconpack/firefighter.webp'
import firstPlaceMedal from '../code-only/assets/emoji_iconpack/first_place_medal.webp'
import folder from '../code-only/assets/emoji_iconpack/folder.webp'
import france from '../code-only/assets/emoji_iconpack/france.webp'
import frenchFries from '../code-only/assets/emoji_iconpack/french_fries.webp'
import funeralUrn from '../code-only/assets/emoji_iconpack/funeral_urn.webp'
import gameDice from '../code-only/assets/emoji_iconpack/game dice.webp'
import gemStone from '../code-only/assets/emoji_iconpack/gem_stone.webp'
import glasses from '../code-only/assets/emoji_iconpack/glasses.webp'
import globeShowingAmericas from '../code-only/assets/emoji_iconpack/globe_showing_americas.webp'
import greenApple from '../code-only/assets/emoji_iconpack/green_apple.webp'
import greenBook from '../code-only/assets/emoji_iconpack/green_book.webp'
import guard from '../code-only/assets/emoji_iconpack/guard.webp'
import hammerAndWrench from '../code-only/assets/emoji_iconpack/hammer_and_wrench.webp'
import handshake from '../code-only/assets/emoji_iconpack/handshake.webp'
import highVoltage from '../code-only/assets/emoji_iconpack/high-voltage.webp'
import homework from '../code-only/assets/emoji_iconpack/homework.webp'
import hotBeverage from '../code-only/assets/emoji_iconpack/hot_beverage.webp'
import hourglassNotDone from '../code-only/assets/emoji_iconpack/hourglass_not_done.webp'
import house from '../code-only/assets/emoji_iconpack/house.webp'
import indexPointingUp from '../code-only/assets/emoji_iconpack/index_pointing_up.webp'
import kiss from '../code-only/assets/emoji_iconpack/kiss.webp'
import laptop from '../code-only/assets/emoji_iconpack/laptop.webp'
import ledger from '../code-only/assets/emoji_iconpack/ledger.webp'
import lightBulb from '../code-only/assets/emoji_iconpack/light_bulb.webp'
import locked from '../code-only/assets/emoji_iconpack/locked.webp'
import lockedWithKey from '../code-only/assets/emoji_iconpack/locked_with_key.webp'
import lotus from '../code-only/assets/emoji_iconpack/lotus.webp'
import magicWand from '../code-only/assets/emoji_iconpack/magic_wand.webp'
import manHealthWorker from '../code-only/assets/emoji_iconpack/man_health_worker.webp'
import manJudge from '../code-only/assets/emoji_iconpack/man_judge.webp'
import manRaisingHand from '../code-only/assets/emoji_iconpack/man_raising_hand.webp'
import manTechnologist from '../code-only/assets/emoji_iconpack/man_technologist.webp'
import mechanicalArm from '../code-only/assets/emoji_iconpack/mechanical_arm.webp'
import mobilePhone from '../code-only/assets/emoji_iconpack/mobile_phone.webp'
import moneyBag from '../code-only/assets/emoji_iconpack/money_bag.webp'
import moneyMouthFace from '../code-only/assets/emoji_iconpack/money_mouth-face.webp'
import nauseatedFace from '../code-only/assets/emoji_iconpack/nauseated_face.webp'
import newspaper from '../code-only/assets/emoji_iconpack/newspaper.webp'
import ninja from '../code-only/assets/emoji_iconpack/ninja.webp'
import notebook from '../code-only/assets/emoji_iconpack/notebook.webp'
import notebookWithDecorativeCover from '../code-only/assets/emoji_iconpack/notebook_with_decorative_cover.webp'
import nutAndBolt from '../code-only/assets/emoji_iconpack/nut_and_bolt.webp'
import officeBuilding from '../code-only/assets/emoji_iconpack/office_building.webp'
import olderPerson from '../code-only/assets/emoji_iconpack/older_person.webp'
import openBook from '../code-only/assets/emoji_iconpack/open_book.webp'
import orangeBook from '../code-only/assets/emoji_iconpack/orange_book.webp'
import packageBox from '../code-only/assets/emoji_iconpack/package.webp'
import pageWithCurl from '../code-only/assets/emoji_iconpack/page_with_curl.webp'
import pancakes from '../code-only/assets/emoji_iconpack/pancakes.webp'
import person from '../code-only/assets/emoji_iconpack/person.webp'
import personFeedingBaby from '../code-only/assets/emoji_iconpack/person_feeding_baby.webp'
import personGettingMassage from '../code-only/assets/emoji_iconpack/person_getting_massage.webp'
import personInBed from '../code-only/assets/emoji_iconpack/person_in_bed.webp'
import personInManualWheelchair from '../code-only/assets/emoji_iconpack/person_in_manual_wheelchair.webp'
import personWhiteHair from '../code-only/assets/emoji_iconpack/person_white_hair.webp'
import pill from '../code-only/assets/emoji_iconpack/pill.webp'
import pilot from '../code-only/assets/emoji_iconpack/pilot.webp'
import pirateFlag from '../code-only/assets/emoji_iconpack/pirate_flag.webp'
import pizza from '../code-only/assets/emoji_iconpack/pizza.webp'
import potOfFood from '../code-only/assets/emoji_iconpack/pot_of_food.webp'
import pottedPlant from '../code-only/assets/emoji_iconpack/potted_plant.webp'
import punch from '../code-only/assets/emoji_iconpack/punch.webp'
import purse from '../code-only/assets/emoji_iconpack/purse.webp'
import radioactive from '../code-only/assets/emoji_iconpack/radioactive.webp'
import receipt from '../code-only/assets/emoji_iconpack/receipt.webp'
import recycle from '../code-only/assets/emoji_iconpack/recycle.webp'
import redBook from '../code-only/assets/emoji_iconpack/red_book.webp'
import rocket from '../code-only/assets/emoji_iconpack/rocket.webp'
import safetyVest from '../code-only/assets/emoji_iconpack/safety_vest.webp'
import salad from '../code-only/assets/emoji_iconpack/salad.webp'
import scientist from '../code-only/assets/emoji_iconpack/scientist.webp'
import screamingFace from '../code-only/assets/emoji_iconpack/screaming_face.webp'
import screwdriver from '../code-only/assets/emoji_iconpack/screwdriver.webp'
import seeding from '../code-only/assets/emoji_iconpack/seeding.webp'
import shield from '../code-only/assets/emoji_iconpack/shield.webp'
import sneezingFace from '../code-only/assets/emoji_iconpack/sneezing_face.webp'
import speechBalloon from '../code-only/assets/emoji_iconpack/speech-balloon.webp'
import starStruck from '../code-only/assets/emoji_iconpack/star_struck.webp'
import student from '../code-only/assets/emoji_iconpack/student.webp'
import sushi from '../code-only/assets/emoji_iconpack/sushi.webp'
import sweatDroplet from '../code-only/assets/emoji_iconpack/sweat_droplet.webp'
import syringe from '../code-only/assets/emoji_iconpack/syringe.webp'
import taxi from '../code-only/assets/emoji_iconpack/taxi.webp'
import technologist from '../code-only/assets/emoji_iconpack/technologist.webp'
import telephone from '../code-only/assets/emoji_iconpack/telephone.webp'
import thumbUp from '../code-only/assets/emoji_iconpack/thumb_up.webp'
import toothbrush from '../code-only/assets/emoji_iconpack/toothbrush.webp'
import tornado from '../code-only/assets/emoji_iconpack/tornado.webp'
import tubeTest from '../code-only/assets/emoji_iconpack/tube_test.webp'
import umbrella from '../code-only/assets/emoji_iconpack/umbrella.webp'
import umbrellaOnGround from '../code-only/assets/emoji_iconpack/umbrella_on_ground.webp'
import umbrellaWithRainDrops from '../code-only/assets/emoji_iconpack/umbrella_with_rain_drops.webp'
import volcano from '../code-only/assets/emoji_iconpack/volcano.webp'
import waving from '../code-only/assets/emoji_iconpack/waving.webp'
import wheelchair from '../code-only/assets/emoji_iconpack/wheelchair.webp'
import window from '../code-only/assets/emoji_iconpack/window.webp'
import womanRaisingHand from '../code-only/assets/emoji_iconpack/woman_raising_hand.webp'
import womanSwimming from '../code-only/assets/emoji_iconpack/woman_swimming.webp'
import womanTechnologist from '../code-only/assets/emoji_iconpack/woman_technologist.webp'
import wrench from '../code-only/assets/emoji_iconpack/wrench.webp'
import zipperMouthFace from '../code-only/assets/emoji_iconpack/zipper_mouth_face.webp'

export const emoji = {
  adhesiveBandage,
  alienMonster,
  ambulance,
  amphora,
  armoredChicken,
  astronaut,
  automobile,
  balanceScale,
  banknoteDollar,
  banknoteEuro,
  bank,
  barberPole,
  beerMug,
  bellshop,
  blueBook,
  brain,
  brick,
  briefcase,
  buildingConstruction,
  calendar,
  cameraWithFlash,
  cannedFood,
  cardFileBox,
  checkMark,
  checkMarkButton,
  child,
  clipboard,
  cloudWithRain,
  circleCheck,
  circleExclamation,
  coin,
  collision,
  computerDisk,
  construction,
  constructionWorker,
  cook,
  couchAndLamp,
  coupleWithHeart,
  crayon,
  creditCard,
  crown,
  deliveryTruck,
  derelictHouse,
  dove,
  downcastSweat,
  droplet,
  electricPlug,
  envelope,
  eyes,
  faceWithCrossedOutEyes,
  faceWithHeadBandage,
  faceWithThermometer,
  factoryWorker,
  fearfulFace,
  fire,
  fireExtinguisher,
  firefighter,
  firstPlaceMedal,
  folder,
  france,
  frenchFries,
  funeralUrn,
  gameDice,
  gemStone,
  glasses,
  globeShowingAmericas,
  greenApple,
  greenBook,
  guard,
  hammerAndWrench,
  handshake,
  highVoltage,
  homework,
  hotBeverage,
  hourglassNotDone,
  house,
  indexPointingUp,
  kiss,
  laptop,
  ledger,
  lightBulb,
  locked,
  lockedWithKey,
  lotus,
  magicWand,
  manHealthWorker,
  manJudge,
  manRaisingHand,
  manTechnologist,
  mechanicalArm,
  mobilePhone,
  moneyBag,
  moneyMouthFace,
  nauseatedFace,
  newspaper,
  ninja,
  notebook,
  notebookWithDecorativeCover,
  nutAndBolt,
  officeBuilding,
  olderPerson,
  openBook,
  orangeBook,
  packageBox,
  pageWithCurl,
  pancakes,
  person,
  personFeedingBaby,
  personGettingMassage,
  personInBed,
  personInManualWheelchair,
  personWhiteHair,
  pill,
  pilot,
  pirateFlag,
  pizza,
  potOfFood,
  pottedPlant,
  punch,
  purse,
  radioactive,
  receipt,
  recycle,
  redBook,
  rocket,
  safetyVest,
  salad,
  scientist,
  screamingFace,
  screwdriver,
  seeding,
  shield,
  sneezingFace,
  speechBalloon,
  starStruck,
  student,
  sushi,
  sweatDroplet,
  syringe,
  taxi,
  technologist,
  telephone,
  thumbUp,
  toothbrush,
  tornado,
  tubeTest,
  umbrella,
  umbrellaOnGround,
  umbrellaWithRainDrops,
  volcano,
  waving,
  wheelchair,
  window,
  womanRaisingHand,
  womanSwimming,
  womanTechnologist,
  wrench,
  zipperMouthFace,
} as const

export type EmojiName = keyof typeof emoji
